import { render, staticRenderFns } from "./OfficialAgency.vue?vue&type=template&id=7856c39c"
import script from "./OfficialAgency.vue?vue&type=script&lang=js"
export * from "./OfficialAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports